// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconRightCarouselInac: React.FC = () => {
    return (
        <svg
            version="1.1"
            width="56px"
            height="56px"
            viewBox="0 0 56.0 56.0"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            fill="currentColor"
        >
            <defs>
                <clipPath>
                    <path d="M1366,0 L1366,6646 L0,6646 L0,0 L1366,0 Z"></path>
                </clipPath>
                <clipPath>
                    <path d="M28,0 C43.463973,0 56,12.536027 56,28 C56,43.463973 43.463973,56 28,56 C12.536027,56 0,43.463973 0,28 C0,12.536027 12.536027,0 28,0 Z"></path>
                </clipPath>
                <clipPath>
                    <path d="M2.5,0 L12.5,10 L2.5,20 L0,17.5 L7.5,10 L0,2.5 L2.5,0 Z"></path>
                </clipPath>
            </defs>
            <g transform="translate(-1029.0 -1341.0)">
                <g clipPath="url(#i0)">
                    <g transform="translate(1029.0 1341.0)">
                        <g clipPath="url(#i1)">
                            <polygon points="0,0 56,0 56,56 0,56 0,0" stroke="none" fill="#FFFFFF"></polygon>
                        </g>
                        <g transform="translate(23.0 18.0)">
                            <g clipPath="url(#i2)">
                                <polygon points="0,0 12.5,0 12.5,20 0,20 0,0" stroke="none" fill="#A95E26"></polygon>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(IconRightCarouselInac);
